import { CheckCircleOutlined } from '@ant-design/icons'
import { Avatar, Card, Typography } from 'antd'
import { isBoolean } from 'lodash'
import React from 'react'

import { useGetGroupMemberRequestQuery } from '@/generated/graphql'

import { GroupReplyButton } from './group-reply-button.component'

export const SingleGroupApply: React.FC<{ requestId: number }> = ({ requestId }) => {
  const { data } = useGetGroupMemberRequestQuery({
    fetchPolicy: 'no-cache',
    variables: {
      requestId,
    },
  })

  if (!data) {
    return null
  }

  const groupMemberRequest = data.groupMemberRequest
  const isApproved = isBoolean(groupMemberRequest.isApproved)

  return (
    <Card style={{ minWidth: '100%' }} title={`申请加入群组：${groupMemberRequest.group.name}`}>
      <Card.Meta
        avatar={<Avatar src={groupMemberRequest.creator.avatarUrl} />}
        title={`申请人：${groupMemberRequest.creator.name}`}
        description={
          isApproved && (
            <Typography.Text type='success'>
              <CheckCircleOutlined />{' '}
              {`群组管理员${groupMemberRequest.approver ? groupMemberRequest.approver.name : ''}已处理`}
            </Typography.Text>
          )
        }
      />
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <GroupReplyButton disabled={isApproved} requestId={requestId} name={groupMemberRequest.creator.name} />
      </div>
    </Card>
  )
}
